const MediumIcon = /*#__PURE__*/ [
  ["circle", { cx: "6.5", cy: "12", r: "4.5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["ellipse", { cx: "15.5", cy: "12", rx: "2.5", ry: "4.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["ellipse", { cx: "21", cy: "12", rx: "1", ry: "4.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export { MediumIcon as default };
//# sourceMappingURL=MediumIcon.js.map
